import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'formik';
import _debounce from 'lodash/debounce';
import _pick from 'lodash/pick';
import isEqual from 'react-fast-compare';

const saveableAttributes = ['values'];

class FormikPersist extends Component {
  saveForm = _debounce((data) => {
    const filteredData = _pick(data, saveableAttributes);
    if (this.props.isSessionStorage) {
      window.sessionStorage.setItem(this.props.name, JSON.stringify(filteredData));
    } else {
      window.localStorage.setItem(this.props.name, JSON.stringify(filteredData));
    }
  }, this.props.debounce);

  clearFormState = () => {
    if (this.props.isSessionStorage) {
      window.sessionStorage.removeItem(this.props.name);
    } else {
      window.localStorage.removeItem(this.props.name);
    }
  };

  componentDidUpdate(prevProps) {
    if (!isEqual(prevProps.formik, this.props.formik)) {
      // added to clear form state if status set to submitted
      if (this.props.formik.status === 'submitted') {
        // must cancel debounced saveForm otherwise form state will get written after clearing
        this.saveForm.cancel();

        this.clearFormState(this.props.name);
      } else {
        this.saveForm(this.props.formik);
      }
    }
  }

  componentDidMount() {
    const maybeState = this.props.isSessionStorage
      ? window.sessionStorage.getItem(this.props.name)
      : window.localStorage.getItem(this.props.name);
    if (maybeState && maybeState !== null) {
      // include most of current state so that we have objects for all of the normal
      // formik stuff since we're only storing values in local storage
      this.props.formik.setFormikState({
        ...this.props.formik,
        ...JSON.parse(maybeState),
      });
    }
  }

  render() {
    return null;
  }
}

FormikPersist.propTypes = {
  name: PropTypes.string.isRequired,
  debounce: PropTypes.number,
  isSessionStorage: PropTypes.bool,
  formik: PropTypes.object.isRequired,
};

FormikPersist.defaultProps = {
  debounce: 300,
  isSessionStorage: false,
};

export default connect(FormikPersist);
